import { render, staticRenderFns } from "./AdicionarVideos.vue?vue&type=template&id=de36515e&"
import script from "./AdicionarVideos.vue?vue&type=script&lang=js&"
export * from "./AdicionarVideos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports